import { Routes } from '@angular/router';

// Public, unauthenticated campaign pages. Backed by GET /v1/public/campaigns/{id}
// (anothertrip-SAM) which only returns PUBLIC + ACTIVE campaigns; anything else
// is a 404. The page itself sets <meta name="robots" content="noindex"> in v1.
export const campaignRoutes: Routes = [
  {
    path: 'campaigns/:campaignId',
    title: 'Campaign · AnotherTrip',
    loadComponent: () =>
      import('./pages/public-campaign/public-campaign.page').then((m) => m.PublicCampaignPage),
  },
];
